import { CountrySelect, StateSelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";

export default function CountryDropdown({ formik }) {
  
  return (
    <div className="d-grid grid-count-2 align-items-center flex-wrap gap-3">
      <div className="form-box">
        <label htmlFor="country" className="form-label mb-2 fs-14 fw-medium text-heading">
          Country
        </label>
        <CountrySelect
          id="country"
          value={formik.values.country.id}
          onChange={(e) => {
            formik.setFieldValue("country", e);
            formik.setFieldValue("state", "");
          }}
          placeHolder="Select Country"
        />
      
      </div>
      <div className="form-box">
        <label htmlFor="state" className="form-label mb-2 fs-14 fw-medium text-heading">
          State
        </label>
        <StateSelect
          id="state"
          countryid={formik.values.country.id}
          value={formik.values.state.id}
          onChange={(e) => {
            formik.setFieldValue("state", e);
          }}
          placeHolder="Select State"
        />
      </div>
    </div>
  );
}
